import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from '@mui/material';
import getBotResponse from './getBotResponse.js';


function ChatButtons({ globalData, setGlobalData, currentChatHistoryData, updateChatHistoryData, 
    allNodeData, setLastNode, panelView, setPanelView, showInfoPanel, setShowInfoPanel, sendAuthorMessage, 
    conversationID, setBotResponse, storyID, userID, chatContainerRef}) {

    const [fetchDataTrigger, setFetchDataTrigger] = useState(false);
    const [faqNodes, setFaqNodes] = useState([]);

    // Determines if we want to show the ending flow buttons: 
    const [showReaderQuestionsButton, setShowReaderQuestionsButton] = useState(true);
    const [removeAllButtons, setRemoveAllButtons] = useState(false);

    const [triggerBotResponse, setTriggerBotResponse] = useState(false); // Logic for whether we show bot response for end flow

    // Get all the FAQ nodes associated with the current node 
    useEffect(() => {
        let faqIDs = [];
        let computedFaqNodes = [];
        // Check if the 'allNodeData' array has data.
        if (allNodeData) {
            // Find the node that matches the current node ID.
            const currentNode = allNodeData.find(node => node._id === globalData.currentNodeID);

            // If the 'currentNode' exists, get its 'linkedFAQ'; otherwise, default to an empty array.
            const faqIDs = currentNode ? currentNode.linkedFAQ : [];

            // Filter the 'allNodeData' array to get nodes that have IDs present in the 'faqIDs' array.
            const computedFaqNodes = allNodeData.filter(node => faqIDs.includes(node._id));

            // Update the 'faqNodes' state with the filtered nodes.
            setFaqNodes(computedFaqNodes);
        }
    }, [allNodeData, globalData.currentNodeID]);

    // Handles what happens when an FAQ pill button is pressed
    const showButtonContent = (faqIndex) => {
        const selectedNode = faqNodes[faqIndex];

        // Create a new array without the selected FAQ button and causes a re-render 
        // so that the button that has been pressed no longer displays
        const updatedFaqNodes = [...faqNodes];
        updatedFaqNodes.splice(faqIndex, 1);
        setFaqNodes(updatedFaqNodes);

        let newChatHistory = []
        if(selectedNode.pictureAbove) {
            newChatHistory = [
                ...currentChatHistoryData,
                { role: 'user', content: selectedNode.nodeTitle },
                { role: 'assistant', content: selectedNode.content, image: selectedNode.pictureAbove } // CHECK THAT THIS WORKS
            ];
        } else {
        newChatHistory = [
            ...currentChatHistoryData,
            { role: 'user', content: selectedNode.nodeTitle },
            { role: 'assistant', content: selectedNode.content }
        ];
    }
        updateChatHistoryData(newChatHistory);
    };


    // Shows the next point when someone clicks the "makes sense. next point" button 
    const showNextPoint = () => {

        // Find the ID of the next node 
        const nextNodeID = globalData.nextNodeID;
        if (nextNodeID === "") {
            setLastNode(true);
        }

        let targetContent = null;
        let targetImage = null;
        let newNextNodeID = null;
        let newChatHistory = [];

        for (let i = 0; i < allNodeData.length; i++) {
            if (allNodeData[i]._id === nextNodeID) {
                targetContent = allNodeData[i].content;
                newNextNodeID = allNodeData[i].next[0];


                if (allNodeData[i].pictureAbove) {
                    targetImage = allNodeData[i].pictureAbove;
                    newChatHistory = [
                        ...currentChatHistoryData,
                        { role: 'user', content: "Makes sense. Next point." },
                        { role: 'assistant', content: targetContent, image: targetImage }
                    ];
                } else {
                    newChatHistory = [
                        ...currentChatHistoryData,
                        { role: 'user', content: "Makes sense. Next point." },
                        { role: 'assistant', content: targetContent }
                    ];
                }

                updateChatHistoryData(newChatHistory);

                // Update the globalData with the new nextNodeID
                setGlobalData(prevData => ({
                    currentNodeID: nextNodeID,
                    nextNodeID: newNextNodeID
                }));
                break;
            }
        }
        setFetchDataTrigger(prev => !prev);

        // Ensure the update to the DOM has completed before scrolling
        setTimeout(() => {
            const chatContainer = chatContainerRef.current;
            if (chatContainer) {
                // Find the last chatMessage div
                const chatMessages = chatContainer.getElementsByClassName('chatMessage');
                const lastMessage = chatMessages[chatMessages.length - 2]; 
                if (lastMessage) {
                    // Set scrollTop to the offsetTop of the last message to bring it to the top of the visible area of chatContainer
                    chatContainer.scrollTop = lastMessage.offsetTop - chatContainer.offsetTop;
                }
            }
        }, 0); // setTimeout with 0 delay to allow for state/DOM updates to complete
    };

    // Anytime a user clicks enter anywhere on the page, show next point
    // However, this action is NOT triggered if the user is pressing enter to submit a message in chat-input
    useEffect(() => {
        const handleKeyDown = (e) => {
            // Check for the Enter key and make sure it's not being pressed inside an element with id/class chat-input
            if (e.key === 'Enter' && !['chat-input'].includes(e.target.id) && !e.target.classList.contains('chat-input')) {
                showNextPoint();
            }
        };
        // Attach the event listener
        document.addEventListener('keydown', handleKeyDown);

        // Cleanup by removing the event listener when the component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [currentChatHistoryData, allNodeData, globalData]);  // Include any dependencies for the showNextPoint function here

    const showEndFlow = async () => {
        setRemoveAllButtons(true); // Get rid of all buttons apart from "show me what others said"

        // Update chat history to ask the question
        const newChatHistory = [
            ...currentChatHistoryData,
            { role: 'user', content: "Summarize our conversation" },
        ];
        await updateChatHistoryData(newChatHistory);

        // Write to chat history
        await writeToChatHistory("Summarize our conversation");

        // Set the flag to true to indicate that the next update to currentChatHistoryData
        // should trigger the bot response.
        setTriggerBotResponse(true);
    }

        // Function to write messages to user's chat history.
        const writeToChatHistory = async (message) => {
            const messageData = {
                storyID: storyID,
                conversationID: conversationID.current,
                userID: userID,
                text: message,
            };
    
            try {
                const response = await fetch('https://versify-back-b066d2bc73d1.herokuapp.com/sendUserMessage', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(messageData),
                });
    
                const data = await response.json();
                if (response.ok) {
                    // console.log('Message sent successfully:', data);
                } else {
                    // console.error('Error adding message:', data.error);
                }
            } catch (error) {
                // console.error('Failed to send author message:', error);
            }
        };

    /// Triggers the bot to provide a summary
    useEffect(() => {
        if (triggerBotResponse) {
            // Now we reset the flag to avoid calling the bot response again unintentionally
            setTriggerBotResponse(false);
    
            // Assuming getBotResponse itself is a function that handles async operations
            getBotResponse(
                currentChatHistoryData,
                updateChatHistoryData,
                sendAuthorMessage,
                storyID,
                conversationID,
                userID,
                setBotResponse
            );
        }
    }, [triggerBotResponse]); 

    function showQuestionsPanel() {
        if (!showInfoPanel) { // If panel is hidden, unhide 
            setShowInfoPanel(true);
        }
        setPanelView('questions'); // Display questions view
        setShowReaderQuestionsButton(false); // Do not show the 'show me what other readers said' button again 
    }

    return (
        <div className='chat-buttons' style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginLeft: '50px',
            paddingBottom: '30px',
            flexWrap: 'wrap',
            gap: '10px'  // This will create space between items
        }}>
            {/* FAQ Pill Buttons */}
            {faqNodes.map((node, index) => (
                !removeAllButtons ? (
                    <div
                        className="pill-button"
                        onClick={() => showButtonContent(index)}
                        style={{ cursor: 'pointer' }}
                        key={node._id}
                    >
                        {node.nodeTitle}
                    </div>
                ) : null
            ))}

            {/* Conditionally render the next point or summarize buttons */}
            {globalData.nextNodeID ? (
                <Tooltip title="Press 'Enter' anywhere on the page" placement="top">
                    <div className="pill-button" onClick={showNextPoint} style={{
                        cursor: 'pointer',
                        color: '#129534',
                        border: '2px solid #129534'
                    }}>
                        Makes sense. Next point.
                    </div>
                </Tooltip>
            ) : (
                <>
                    {!removeAllButtons ? (
                        <div className="pill-button" onClick={showEndFlow} style={{
                            cursor: 'pointer',
                            color: '#129534',
                            border: '2px solid #129534'
                        }}>
                            Summarize our conversation.
                        </div>
                        ) : null
                        }
                        {/* {
                            showReaderQuestionsButton ? (
                                <div className="pill-button" onClick={showQuestionsPanel} style={{
                                    cursor: 'pointer',
                                    color: '#129534',
                                    border: '2px solid #129534'
                                }}>
                                    Show me what other readers have asked!
                                </div>
                            ) : null
                        } */}

                    </>
            )}

        </div>

    );
}


export default ChatButtons;
